/** One-click OpenAI-compatible provider presets. */

export interface ProviderPreset {
  id: string;
  name: string;
  baseUrl: string;
  /** Hint shown under the name */
  hint: string;
  /** Prefer false — CORS proxy is a MITM for keys + chat; user must opt in */
  useCorsProxy: boolean;
  /** API key optional (e.g. local Ollama) */
  apiKeyOptional?: boolean;
  /** Placeholder for key field */
  apiKeyPlaceholder?: string;
  /** Docs / signup URL */
  docsUrl?: string;
}

export const PROVIDER_PRESETS: ProviderPreset[] = [
  {
    id: 'openai',
    name: 'OpenAI',
    baseUrl: 'https://api.openai.com/v1',
    hint: 'GPT-4o, o-series, etc.',
    // Proxy off by default — user must acknowledge MITM risk
    useCorsProxy: false,
    apiKeyPlaceholder: 'sk-…',
    docsUrl: 'https://platform.openai.com/api-keys',
  },
  {
    id: 'openrouter',
    name: 'OpenRouter',
    baseUrl: 'https://openrouter.ai/api/v1',
    hint: 'Many models, one key',
    useCorsProxy: false,
    apiKeyPlaceholder: 'sk-or-…',
    docsUrl: 'https://openrouter.ai/keys',
  },
  {
    id: 'ppq',
    name: 'PPQ.ai',
    baseUrl: 'https://api.ppq.ai/v1',
    hint: 'Pay-per-use · crypto top-up · 500+ models',
    useCorsProxy: false,
    apiKeyPlaceholder: 'sk-…',
    docsUrl: 'https://ppq.ai/api-docs',
  },
  {
    id: 'routstr',
    name: 'Routstr',
    baseUrl: 'https://api.routstr.com/v1',
    hint: 'Cashu / Lightning · permissionless AI',
    useCorsProxy: false,
    apiKeyPlaceholder: 'sk-… or cashuA…',
    docsUrl: 'https://docs.routstr.com/client/integration/',
  },
  {
    id: 'groq',
    name: 'Groq',
    baseUrl: 'https://api.groq.com/openai/v1',
    hint: 'Fast open models',
    useCorsProxy: false,
    apiKeyPlaceholder: 'gsk_…',
    docsUrl: 'https://console.groq.com/keys',
  },
  {
    id: 'together',
    name: 'Together AI',
    baseUrl: 'https://api.together.xyz/v1',
    hint: 'Open-weight cloud',
    useCorsProxy: false,
    apiKeyPlaceholder: '…',
    docsUrl: 'https://api.together.xyz/',
  },
  {
    id: 'ollama',
    name: 'Ollama',
    baseUrl: 'http://localhost:11434/v1',
    hint: 'Local only when OpenDork is HTTP (dev) — not from HTTPS deploy',
    useCorsProxy: false,
    apiKeyOptional: true,
    apiKeyPlaceholder: 'ollama (or leave blank)',
    docsUrl: 'https://ollama.com',
  },
  {
    id: 'opencode',
    name: 'OpenCode Go',
    baseUrl: 'https://opencode.ai/zen/go/v1',
    hint: 'OpenCode / Zen API',
    useCorsProxy: false,
    apiKeyPlaceholder: 'sk-…',
  },
  {
    id: 'custom',
    /** Empty so the form title stays generic; user sets their own label */
    name: '',
    baseUrl: '',
    hint: 'Any /v1 chat + models endpoint — LiteLLM, vLLM, Azure, self-hosted, …',
    useCorsProxy: false,
    // Many gateways accept a dummy key; user can leave blank and we store a placeholder
    apiKeyOptional: true,
    apiKeyPlaceholder: 'sk-… (or leave blank if the server ignores auth)',
    docsUrl: undefined,
  },
];
